import routeMap from "../router_map";

export default {
  path: "/swapForex",
  meta: {
    title: "多币种换汇",
    rank: 8
  },
  children: [
    {
      path: "/swapForex/swapForex",
      name: "swapForex",
      meta: {
        title: "换汇",
        visible: "0",
        operate: "0"
      }
    },
    ...routeMap["/swapForex/swapForex"],
    {
      path: "/swapForex/swapForexQuery",
      name: "swapForexQuery",
      meta: {
        title: "换汇记录",
        visible: "0",
        operate: "0"
      }
    },
    ...routeMap["/swapForex/swapForexQuery"]
  ]
};
